<template>
  <yiban-tool :flow="flow"> </yiban-tool>
</template>
<script>
import yibanTool from "./yibanTool.vue";
export default {
  components: { yibanTool },
  data() {
    return {
      flow: {
          id: "1621061241873154050",
          name: "小修管理",
          name1: "小修待办处理",
        },
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/yhgl/yibanchuli1.vue